import { FC, useMemo } from 'react'
import { VLPOption, SelectedOption } from '@storefronts/common-types'
import {
    VariantTitleContainer,
    VariantTitleText,
    VariantTitleValue,
} from '../../styled/variantComponents'

interface VariantTitleProps {
    selectedOptions: SelectedOption[]
    option: VLPOption
}

export const VariantTitle: FC<VariantTitleProps> = ({
    selectedOptions,
    option,
}) => {
    const selectedValue = useMemo(() => {
        const selectedOption = selectedOptions.find(
            (opt) => opt.name === option.name,
        )
        return selectedOption?.value || null
    }, [option, selectedOptions])

    return (
        <VariantTitleContainer>
            <VariantTitleText>
                {/* option.name is the variant option name from Shopify (e.g., "Color", "Size", "Material") */}
                {option.name}
                {selectedValue && (
                    <>
                        : <VariantTitleValue>{selectedValue}</VariantTitleValue>
                    </>
                )}
            </VariantTitleText>
        </VariantTitleContainer>
    )
}
